import { useState } from "react";

export const useDisclosure = () => {
  const [state, setState] = useState(false);

  return {
    isOpen: state,
    onClose: () => setState(false),
    onOpen: () => setState(true),
  };
};
